// utils/isDeviceFormDirty.js
const norm = (v) => {
  if (v === undefined || v === null) return null;
  if (typeof v === "string") {
    const s = v.trim();
    return s === "" ? null : s;
  }
  return v;
};

export function isDeviceFormDirty(existing, form) {
  const fields = [
    "propertyId",
    "buildingId",
    "unitId",
    "room",
    "assetType",
    "label",
    "notes",
  ];

  for (const k of fields) {
    const a =
      k === "unitId"
        ? existing?.unitId ?? null
        : norm(existing?.[k]);

    const b =
      k === "unitId"
        ? form?.unitId || null
        : norm(form?.[k]);

    if (a !== b) {
      return true;
    }
  }

  return false;
}
